<template>
  <!-- 付款审核 -->
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
            trackCode='approvalPaymentApplyList-1'
          >
            <template slot="batch-search-btn">
              <el-button
                type="primary"
                :size="formSize"
                :loading="loading"
                @click="handleBatchSearch()"
              >
                批量查询
              </el-button>
            </template>
          </jr-search2>
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList">
            <template #payWays>
              <page-select-cascader
                :selectOptions="selectWayOptions"
                :selectList="queryForm.selectList"
                :cascaderStyle="{minWidth: '300px'}"
                @change="cascaderChange"
                :cascaderProps="cascaderProps"
                :hasAll="false"
              />
            </template>
          </page-select-groups>
          <div class="fan-search-col fan-search-right">
            <!-- 表格数据配置 -->
            <jr-columns-config
              :columnsKey="columnsKey"
              :tableColumn="tableColumn"
              :selectTableColumn="selectTableColumn"
              :recommendedColumn="recommendedColumn"
              @confirm="handleConfirm"
            />
            <btns-operate
              :multipleSelection="multipleSelection"
              :isBatch="true"
              @success="getList"
            />
            <div style="margin-left: 10px" v-if="$has('FWS-KJSH-FKSH-DC')">
              <page-export-button
                title="付款审核数据导出"
                buttonText="导出"
                exportServe="fin_payment_paymentApplyReport"
                :exportParams="exportParams"
                :total="total"
                :isLimit="true"
                trackCode='approvalPaymentApplyList-3'
              />
            </div>
          </div>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="selectTableColumn"
          ref="paymentApplyListRef"
          @selection-change="handleSelectionChange"
        >
          <template v-slot:orderNumber="{row}">
            <jr-tooltip
              :content="row.orderNumber"
              type="popover"
              :isFilter="true"
            />
          </template>
          <template v-slot:businessName="{row}">
            <span>{{row.businessNo || '-'}}/{{row.businessName || '-'}}</span>
          </template>
          <template v-slot:options="{row}">
            <btns-operate
              :current="row"
              @success="getList"
            />
          </template>
        </jr-table>
      </template>

      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>

    <!-- 详情 -->
    <detail
      :visible.sync="isDetailShow"
      :payment-no.sync="detailObj.paymentNo"
      :pay-apply-number.sync="detailObj.payApplyNumber"
      @refresh="getList"
    />
    <!-- 批量搜索 -->
    <batch-search
      :visible.sync="isBatchSearchShow"
      :type-list="batchSearchTypeList"
      :searchType="queryForm.searchType"
      :loading="loading"
      @confirm="handleBatchSearchConfirm"
      trackCode='approvalPaymentApplyList-2'
    />
  </div>
</template>

<script>
import { getPaymentApplyList } from '@/api/approval/payment-apply';
import detail from './components/detail';
import { setStatusColor } from '@/filters/index';
// import sourceSelect from '@/components/source-select';
import btnsOperate from './components/btns-operate';
import { getMonthDate } from '@/utils/date';
import * as _ from 'lodash';

const queryFormDefault = {
  beginTime: '', // 开始时间
  endTime: '', // 结束时间
  page: 1,
  limit: 20,
  searchContent: '', // 搜索值
  searchType: '1',
  approvalStatus: '', // 审核状态 1 待审核 2 已通过 -1 已驳回
  transType: 2, // 订单交易类型1=自营2=服务商
  timeType: '1',
  sourceList: [],
  selectList: [],
  payWays: [], // 付款渠道
  payMode: '', // 付款方式
};

const dictTypes = {
  UnifiedPaymentModleEnum: '/finance/finance-payment/PaymentModleEnum',
};

export default {
  name: 'ApprovalPaymentApplyList',
  components: { detail, btnsOperate },
  data() {
    const list = [
      {
        value: '1',
        label: '业务订单编号',
      }, {
        value: '2',
        label: '付款申请单编号',
      }, {
        value: '3',
        label: '应付单编号',
      }, {
        value: '4',
        label: '供应商编号',
      }, {
        value: '5',
        label: '供应商名称',
      }, {
        value: '6',
        label: '申请人',
      },
    ];
    return {
      cascaderProps: {
        multiple: true,
        checkStrictly: true,
        value: 'value',
        label: 'codeName',
        children: 'childs',
      },
      loading: false,
      queryForm: JSON.parse(JSON.stringify(queryFormDefault)),
      list: [],
      total: 0,
      formList: [
        {
          prop: 'timeType',
          component: 'select-date-picker',
          options: [
            { label: '创建时间', value: '1' },
            { label: '审核时间', value: '2' },
          ],
        },
        {
          prop: 'searchType',
          contentProp: 'searchContent',
          component: 'search-input-select',
          attrs: {
            type: 'text',
            placeholder: '请输入内容',
          },
          options: [...list],
        },
      ],
      isDetailShow: false, // 详情弹窗
      detailObj: {}, // 当前付款信息
      /** ------批量搜索---- */
      batchSearchTypeList: [ // 批量搜索搜索条件集合
        ...list,
      ],
      isBatchSearchShow: false, // 批量搜索
      batchResults: {}, // 批量操作返回结果
      /** ------批量操作---- */
      multipleSelection: [], // 选中的数据
      // 批量操作合并信息
      tableColumn: [
        {
          type: 'selection',
          width: '40',
          align: 'center',
          isShow: () => false,
          show: () => this.$has('FWS-KJSH-FKSH-TGBH'),
          selectable: (row) => this.setDisabled(row),
        },
        {
          prop: 'payApplyNumber',
          label: '付款申请单号',
          minWidth: '1',
          disabled: true,
          trackCode: 'approvalPaymentApplyList-6',
          click: (row) => this.handleDetail(row),
          show: () => this.$has('FWS-KJSH-FKSH-XQ'),
        },
        { prop: 'orderNumber', label: '业务订单编号', minWidth: '1', slotName: 'orderNumber' },
        { prop: 'sourceDesc', label: '归属业务', minWidth: '1' },
        { prop: 'businessName', slotName: 'businessName', label: '供应商编号/名称', minWidth: '1' },
        { prop: 'payeeBusinessName', label: '服务商名称', minWidth: '1' },
        { prop: 'payModeDesc', label: '付款方式', minWidth: '1' },
        { prop: 'payWayDesc', label: '付款渠道', minWidth: '1' },
        { prop: 'payAmount', label: '付款金额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat', disabled: true },
        { prop: 'payReason', label: '付款原因', minWidth: '1', showOverflowTooltip: true },
        { prop: 'cruser', label: '申请人', minWidth: '1' },
        { prop: 'crtime', label: '创建时间', minWidth: '1', filterName: 'formatTime', disabled: true },
        {
          label: '审核状态',
          prop: 'approvalStatus',
          status: 'approvalStatus',
          statusDesc: 'approvalStatusDesc',
          statusColor: (val) => setStatusColor(val, 'approvalStatus'),
        },
        { prop: 'approvalUser', label: '操作人', minWidth: '1' },
        { prop: 'operate', slotName: 'options', label: '操作', width: '110', disabled: true },
      ],
      recommendedColumn: [
        { prop: 'approvalTime', label: '审核时间', minWidth: '1', filterName: 'formatTime' },
        { prop: 'rejectReason', label: '驳回原因', minWidth: '1', showOverflowTooltip: true },
        { prop: 'bankCardNumber', label: '收款账户', minWidth: '1' },
        { prop: 'bankAccountName', label: '收款户名', minWidth: '1' },
      ],
      selectTableColumn: [],
      columnsKey: 'fwsPaymentApplyList',
      selectList: [
        {
          title: '付款审核状态',
          prop: 'approvalStatus',
          dictionaryPath: '/finance/finance-payment/FinPaymentApplyAprStatusEnum',
        },
        {
          title: '付款方式',
          slotName: 'payWays',
          dictionaryPath: dictTypes.UnifiedPaymentModleEnum,
        },
      ],
    };
  },
  computed: {
    selectWayOptions() {
      const { dictData = {} } = this.$store.state.dictionary;
      const arr = _.cloneDeep(dictData[dictTypes.UnifiedPaymentModleEnum]) || [];
      arr.unshift({
        value: 'all',
        codeName: '全部',
      });
      return arr;
    },
    exportParams() {
      const params = {
        ...this.searchParams,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
    searchParams() {
      const params = { ...this.queryForm };
      delete params.selectList;
      return params;
    },
  },
  created() {
    this.init();
  },
  methods: {
    cascaderChange(params) {
      const { selectList, parentSelect, childrenSelect } = params;
      this.queryForm.selectList = selectList;
      this.queryForm.payWays = childrenSelect;
      this.queryForm.payMode = parentSelect;
      this.refreshList();
    },
    resetDate() {
      const { startDate, endDate } = getMonthDate();
      this.queryForm.beginTime = startDate || '';
      this.queryForm.endTime = endDate || '';
    },
    async init() {
      const { approvalStatus, beginTime, payApplyNumber } = this.$route.query;
      this.queryForm.approvalStatus = approvalStatus || '';
      if (!beginTime) {
        this.resetDate();
      }
      /**
       * 【供应链】供应商付款财务自动审核规则更新
       * 飞书消息通知【供应商付款申请人工审核】立即查看跳转携带参数
       */
      if (payApplyNumber) {
        this.queryForm.searchType = '2';
        this.queryForm.searchContent = payApplyNumber;
      }

      try {
        const list = await this.$store.dispatch('dictionary/getUserTemplate', {
          pageKeys: [this.columnsKey],
          columnsKey: this.columnsKey,
          tableColumn: this.tableColumn,
          recommendedColumn: this.recommendedColumn,
        });
        this.selectTableColumn = list;
      } catch (error) {
        this.selectTableColumn = this.tableColumn;
      }
      this.getList();
    },
    // 配置确认
    handleConfirm(values) {
      this.selectTableColumn = values;
      this.$nextTick(() => {
        this.$refs.paymentApplyListRef.doLayout();
      });
    },
    // 多选选择返回结果
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量确认多选限制设置
    setDisabled(row) {
      if ([1, '1'].includes(row.approvalStatus)) {
        return 1;
      }
      return 0;
    },
    // 批量查询提交
    handleBatchSearchConfirm(form) {
      this.batchResults = form;
      const param = { ...queryFormDefault };
      param.searchType = form.searchType || '';
      param.searchContent = (form.list || []).join(',');
      this.queryForm = { ...param };
      this.getList();
    },
    // 批量查询弹窗
    handleBatchSearch() {
      this.isBatchSearchShow = true;
    },
    // 详情
    handleDetail(row = {}) {
      this.detailObj = { ...row };
      this.isDetailShow = true;
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },

    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 列表查询
    async getList() {
      const { approvalStatus, searchContent } = this.queryForm;
      if (!this.queryForm.beginTime && !(searchContent || approvalStatus)) {
        this.resetDate();
      }
      try {
        this.loading = true;
        this.list = [];
        const res = await getPaymentApplyList(this.searchParams);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.isBatchSearchShow = false; // 批量搜索弹窗关闭
      } catch (error) {
        this.list = [];
        this.total = 0;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = JSON.parse(JSON.stringify(queryFormDefault));
      this.resetDate();
      this.$nextTick(() => {
        this.getList();
      });
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
    handleOperateResults() {
      this.getList();
    },
    sourceChange(list) {
      this.queryForm.sourceList = [...list];
      this.refreshList();
    },
  },
};
</script>
